import { getMagnifierLabel } from '../../../../core/components/crosshair/utils/get-magnifier-label.js';
import type {
  FormatterWithPrecision,
  TimeFormatter,
} from '../../../../core/types/formatter.js';
import type { Point } from '../../../../core/types/point.js';
import type { TimeseriesUnit } from '../../../../core/types/timeseries.js';
import type { YAxisScales } from '../../../types/state.js';

/**
 * Creates axis labels based on the data the mouse X and Y position
 * @param yScales - y-axis scales
 * @param mousePosition - [x, y] position of the mouse
 * @param units - value axis units
 * @param yFormatters - external formatter for y axes
 * @returns x and y magnifiers labels
 */
export function generateYMagnifierLabels(
  yScales: YAxisScales,
  mousePosition: Point,
  units: TimeseriesUnit[],
  yFormatters: FormatterWithPrecision[],
) {
  const [leftAxisUnit, rightAxisUnit] = units;
  const [leftFormatter, rightFormatter] = yFormatters;

  const yLabelLeft = getMagnifierLabel(
    leftAxisUnit,
    'y',
    leftFormatter,
    mousePosition,
    yScales.left?.scale,
  );

  const yLabelRight = getMagnifierLabel(
    rightAxisUnit,
    'y',
    rightFormatter,
    mousePosition,
    yScales.right?.scale,
  );

  return {
    left: yLabelLeft,
    right: yLabelRight,
  };
}

export function generateXMagnifierLabels(formatter: TimeFormatter, date: Date) {
  return formatter(date);
}
